webpackJsonp([263791100135453],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fleuron = function Fleuron(_ref) {
	  var link = _ref.link;
	  return _react2.default.createElement(
	    'p',
	    { style: { textAlign: 'center', fontSize: '150%' } },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: link, style: { textDecoration: 'none' } },
	      '\u2766'
	    )
	  );
	};
	
	Fleuron.propTypes = {
	  link: _propTypes2.default.string
	};
	
	Fleuron.defaultProps = {
	  link: '/'
	};
	
	exports.default = Fleuron;
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fleuron = __webpack_require__(40);
	
	var _Fleuron2 = _interopRequireDefault(_Fleuron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'P\u0159\xEDb\u011Bh'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'P\xED\u0161\xED p\u0159\xEDle\u017Eitostn\xED cestovatel\xE9 Martin, Lud\u011Bk a\xA0Vojta.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Po\u010D\xE1tek jejich spole\u010Dn\xFDch cest se datuje do roku 2015, kdy se po 2\xA0metrech piv rozhodli, \u017Ee do roka a do dne vyraz\xED do \u010C\xEDny.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Od t\xE9 doby nav\u0161t\xEDvili ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://www.chinatrip.cz/' },
	        'Hong Kong, Taiwan a v\xFDchodn\xED \u010C\xEDnu'
	      ),
	      ' ',
	      'a\xA0nyn\xED dob\xFDvaj\xED ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Spojen\xE9 st\xE1ty'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(_Fleuron2.default, null)
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-ae05dab9d61ddd7edbca.js